import script from "./ConfirmOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmOverlay.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmOverlay.vue?vue&type=style&index=0&id=8c8d186c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8c8d186c"]])

export default __exports__